<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query.dispatch.wave" clearable placeholder="business.label.wave" type="search" @search-click="refresh"/>
        <vxe-input v-model="query.customer.no" clearable placeholder="business.label.customerNo" type="search" @search-click="refresh"/>
        <vxe-input v-model="query.customer.name" clearable placeholder="business.label.customerName" type="search" @search-click="refresh"/>
        <vxe-input v-model="query.direction.name" clearable placeholder="business.label.distributionDirection" type="search" @search-click="refresh"/>
      </template>
      <template #extra>
        <vxe-input v-model="loadingOrderNo" disabled size="mini"/>
      </template>
      <vxe-table
        ref="table"
        :checkbox-config="{trigger: 'row'}"
        :column-config="{resizable: true}"
        :data="data"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow: true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-overflow
        stripe>
        <vxe-column fixed="left" type="checkbox" width="40"/>
        <vxe-column field="dispatch.wave" title="business.label.wave" width="100"/>
        <vxe-column field="customer.no" title="business.label.customerNo"/>
        <vxe-column field="customer.name" title="business.label.customerName"/>
        <vxe-column field="customer.identifier" title="business.label.identifier"/>
        <vxe-column field="address.detailAddress" title="business.label.detailAddress"/>
        <vxe-column field="direction.name" title="business.label.direction"/>
        <vxe-column field="route.name" title="business.label.route"/>
      </vxe-table>
      <div slot="footer">
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </div>
    </vxe-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { OPERATOR, SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import { findAll } from '@/api/Api'
import { ShipmentOrder } from '@/api/dto/order/ShipmentOrder'

export default {
  name: 'Arranging',
  data() {
    return {
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      loadingOrderNo: null,
      query: new ShipmentOrder(),
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.75)
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      const args = {
        ...this.query.toJSONObject(),
        arranged: false,
        orderStatusRange: { start: 'ISSUED', end: 'TERMINATED' }
      }
      this.loading = true
      findAll('deliveryArrangeFactory', args, this.page, this.size)
        .then(res => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result
          }
        }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = new ShipmentOrder()
      this.refresh()
    },
    addDetail() {
      const details = this.$refs.table.getCheckboxRecords()
      if (details.length > 0) {
        this.$emit('detailsSelected', details)
      }
    }
  }
}
</script>